"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChallengePrizeBodyToJSON = exports.ChallengePrizeBodyFromJSONTyped = exports.ChallengePrizeBodyFromJSON = void 0;
var runtime_1 = require("../runtime");
function ChallengePrizeBodyFromJSON(json) {
    return ChallengePrizeBodyFromJSONTyped(json, false);
}
exports.ChallengePrizeBodyFromJSON = ChallengePrizeBodyFromJSON;
function ChallengePrizeBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'quantity': !(0, runtime_1.exists)(json, 'quantity') ? undefined : json['quantity'],
        'winnerMessage': !(0, runtime_1.exists)(json, 'winnerMessage') ? undefined : json['winnerMessage'],
        'rewardConfigId': !(0, runtime_1.exists)(json, 'rewardConfigId') ? undefined : json['rewardConfigId'],
    };
}
exports.ChallengePrizeBodyFromJSONTyped = ChallengePrizeBodyFromJSONTyped;
function ChallengePrizeBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'quantity': value.quantity,
        'winnerMessage': value.winnerMessage,
        'rewardConfigId': value.rewardConfigId,
    };
}
exports.ChallengePrizeBodyToJSON = ChallengePrizeBodyToJSON;
